import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaionewaycab() {



const cardData = {
  keyword: " Pune to Mumbai One Way Cabs  ",

headingDescription:
  "Velocity Cab provides reliable and comfortable Pune to Mumbai one way cabs, ensuring a smooth and hassle-free journey for business trips, airport transfers, family visits, or leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make your intercity travel stress-free and convenient. We offer flexible booking options with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Pune to Mumbai one way cab services.",

topPlaces: [
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock-cut temples on Elephanta Island, famous for intricate sculptures and historic significance. Travelers from Pune can take a one way cab to the Gateway of India to catch the ferry to these UNESCO World Heritage sites."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large urban forest reserve offering trekking, wildlife, and nature experiences. A one way cab from Pune provides easy access to this green retreat for those seeking a peaceful escape from city life."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling shopping street in South Mumbai, known for its markets, street stalls, and cafes. Travelers arriving from Pune in a one way cab can conveniently explore this vibrant area and continue sightseeing around the city."
  },
 
  {
    title: "Marine Drive",
    description:
      "Marine Drive is a scenic coastal boulevard known as the Queen’s Necklace because of its illuminated night view. A one way cab from Pune makes it convenient to enjoy a relaxing drive or evening walk along this iconic promenade."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s popular seaside attractions, famous for its sandy shores, vibrant street food, and beautiful sunsets. Travelers using a Pune to Mumbai one way cab can enjoy a hassle-free trip directly to the beach for leisure and sightseeing."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a revered Hindu shrine dedicated to Lord Ganesha, located in Prabhadevi. Many travelers from Pune choose to visit this temple using a one way cab for blessings and spiritual experiences."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is an engineering marvel connecting Bandra and Worli with stunning views of the sea and city skyline. A Pune to Mumbai one way cab allows travelers to enjoy a smooth and scenic ride over this landmark."
  },
   {
    title: "Gateway of India",
    description:
      "The Gateway of India is one of Mumbai’s most famous landmarks, located along the Arabian Sea in South Mumbai. Travelers arriving from Pune in a one way cab can easily reach this historic monument to enjoy sightseeing, photography, and ferry rides to Elephanta Island."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a renowned mosque and tomb located on a small island off the Mumbai coast. Travelers arriving from Pune by one way cab can easily access this serene spiritual site for reflection and sightseeing."
  },
  
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also called Pherozeshah Mehta Gardens, are beautifully landscaped terraces on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. Visitors from Pune can reach this serene spot easily via a one way cab to enjoy photography and relaxation."
  }
],



services: [
{
name: "Pune to Mumbai One Way Cab",
description: "Pune to Mumbai one way cab service provides convenient transportation for travelers who need a single-trip journey between Pune and Mumbai. Professional drivers ensure safe highway travel via the Mumbai–Pune Expressway with punctual pickup services from homes, offices, hotels, railway stations, and airport terminals. Vehicles are well maintained and suitable for business travel, tourism visits, and airport transfers. Air-conditioned cars ensure comfortable long-distance journeys. Flexible booking options allow passengers to reserve one way rides easily anytime."
},
{
name: "Pune to Mumbai Taxi One Way",
description: "Pune to Mumbai taxi one way service offers reliable transportation for passengers traveling between the two cities without requiring a return journey. Comfortable vehicles and professional drivers ensure safe and punctual expressway travel. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business travelers, tourists, and families. Spacious vehicles ensure relaxed highway journeys. Flexible booking options allow easy taxi reservations."
},
{
name: "Pune Mumbai Cab One Way",
description: "Pune Mumbai cab one way service provides convenient intercity transportation with comfortable vehicles and experienced drivers. Passengers can travel from Pune to Mumbai quickly through the expressway with safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel, tourism trips, and family visits. Air-conditioned vehicles ensure smooth travel experiences. Flexible booking options allow easy one way ride reservations."
},
{
name: "One Way Cab Pune to Mumbai Airport",
description: "One way cab Pune to Mumbai Airport service offers reliable airport transportation for passengers traveling to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for long-distance airport transfers. Professional drivers ensure punctual pickup and safe highway travel. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Ideal for international and domestic travelers. Flexible booking options allow convenient airport ride reservations."
},
{
name: "One Way Mumbai to Pune",
description: "One way Mumbai to Pune cab service provides convenient single-trip transportation for travelers traveling from Mumbai to Pune city. Vehicles are well maintained and suitable for expressway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Mumbai. Ideal for business travelers, tourists, and families. Flexible booking options allow quick one way ride reservations."
},
{
name: "One Way Pune to Mumbai",
description: "One way Pune to Mumbai taxi service offers comfortable transportation for travelers who need single-trip travel between the two cities. Vehicles are suitable for long-distance highway travel with professional drivers ensuring safe driving services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for corporate travel, tourism visits, and airport transfers. Flexible booking options allow convenient ride scheduling."
},
{
name: "Pune to Mumbai One Way Innova Crysta Taxi Cab",
description: "Pune to Mumbai one way Innova Crysta taxi cab service offers premium SUV transportation for passengers seeking luxury and comfort. Innova Crysta vehicles provide spacious seating and smooth ride quality suitable for expressway travel. Professional drivers ensure punctual pickup and safe driving services across Pune and Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for corporate executives and family travel. Flexible booking options allow convenient one way luxury ride reservations."
},
{
name: "Pune to Mumbai Airport One Way Cab",
description: "Pune to Mumbai Airport one way cab service offers dependable airport transportation for passengers heading to Mumbai Airport terminals. Vehicles provide comfortable seating and luggage space suitable for airport travel. Professional drivers ensure punctual pickup and safe expressway journeys. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Ideal for business travelers and international passengers. Flexible booking options allow easy airport ride reservations."
},
{
name: "Pune to Mumbai One Way Sedan Taxi Cab",
description: "Pune to Mumbai one way sedan taxi cab service provides economical and comfortable transportation for passengers traveling between Pune and Mumbai. Sedan vehicles offer smooth highway travel suitable for small families and business travelers. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow cost-effective one way ride reservations."
},
{
name: "One Way Cab Booking Pune to Mumbai",
description: "One way cab booking Pune to Mumbai service allows travelers to easily reserve single-trip transportation between Pune and Mumbai. Online booking options help passengers confirm rides quickly with transparent pricing. Vehicles are comfortable and suitable for long-distance expressway travel. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options ensure convenient travel planning."
},
{
name: "Pune to Mumbai Cab Round Trip",
description: "Pune to Mumbai cab round trip service provides convenient return transportation for travelers planning journeys between the two cities. Vehicles are comfortable and suitable for highway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business meetings, tourism trips, and family travel. Air-conditioned vehicles ensure comfortable long-distance rides. Flexible booking options allow easy round-trip reservations."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service offers spacious SUV transportation for families and group travelers. The Ertiga vehicle provides comfortable seating and luggage space suitable for highway journeys between Pune and Mumbai. Professional drivers ensure safe driving and punctual pickup services via the expressway. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow convenient cab reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service offers premium SUV transportation for comfortable long-distance travel. Innova vehicles provide spacious seating and smooth ride quality suitable for expressway journeys. Professional drivers ensure safe driving and punctual pickup services across Pune and Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient ride reservations."
},
{
name: "Pune to Mumbai Taxi Services",
description: "Pune to Mumbai taxi services provide dependable transportation with experienced drivers and comfortable vehicles for travelers traveling between the two cities. Vehicles are suitable for expressway travel with safe driving services and punctual pickups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for corporate travel, tourism visits, and family trips. Flexible booking options allow easy taxi reservations."
},
{
name: "One Way Cab",
description: "One way cab service provides convenient transportation for passengers traveling between cities without needing return journeys. Vehicles are well maintained and suitable for long-distance highway travel with professional drivers ensuring safe and punctual trips. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travelers and tourists. Flexible booking options allow quick and easy ride reservations."
},
{
name: "Pune to Mumbai Taxi Service One Way Cab Service",
description: "Pune to Mumbai taxi service one way cab service offers convenient single-trip travel solutions for passengers traveling between Pune and Mumbai. Comfortable vehicles with professional drivers ensure safe expressway travel with punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Flexible booking options allow passengers to easily reserve one way rides."
},
{
name: "Pune to Mumbai Airport Cab Fare",
description: "Pune to Mumbai Airport cab fare services provide transparent pricing for travelers planning airport transfers. Passengers receive clear details about trip cost, toll charges, and driver allowances before booking. Vehicles are comfortable and suitable for highway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Flexible booking options allow convenient airport travel planning."
},
{
name: "Cheapest Cab from Pune to Mumbai Airport",
description: "Cheapest cab from Pune to Mumbai Airport service offers budget-friendly transportation for passengers traveling to Mumbai Airport. Vehicles provide comfortable seating and reliable highway travel at economical rates. Professional drivers ensure safe driving and punctual pickup services across Pune. Pickup services are available from homes, offices, hotels, and railway stations. Flexible booking options allow cost-effective airport ride reservations."
},
{
name: "Best Cab Service Pune to Mumbai",
description: "Best cab service Pune to Mumbai provides reliable and comfortable transportation for travelers traveling between the two major cities of Maharashtra. Vehicles are well maintained and suitable for expressway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travelers, tourists, and families. Flexible booking options allow convenient ride reservations."
}
],

tableData: [
["Pune to Mumbai One Way Cab","Pune to Mumbai Taxi One Way"],
["Pune Mumbai Cab One Way","One Way Cab Pune to Mumbai Airport"],
["One Way Mumbai to Pune","One Way Pune to Mumbai"],
["Pune to Mumbai One Way Innova Crysta Taxi Cab","Pune to Mumbai Airport One Way Cab"],
["Pune to Mumbai One Way Sedan Taxi Cab","One Way Cab Booking Pune to Mumbai"],
["Pune to Mumbai Cab Round Trip","Pune to Mumbai Ertiga Cab"],
["Pune to Mumbai Innova Cab","Pune to Mumbai Taxi Services"],
["One Way Cab","Pune to Mumbai Taxi Service One Way Cab Service"],
["Pune to Mumbai Airport Cab Fare","Cheapest Cab from Pune to Mumbai Airport"],
["Best Cab Service Pune to Mumbai","Pune to Mumbai One Way Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Velocity Cabs provides professional drivers who regularly travel on the Pune to Mumbai Expressway and highway routes. Their experience ensures safe driving, smooth travel, and timely arrival for one way intercity journeys."
  },
  {
    WhyChooseheading: "Affordable One Way Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers competitive and transparent pricing for Pune to Mumbai one way cab services. Customers only pay for the one way journey without unnecessary return charges."
  },
  {
    WhyChooseheading: "24/7 One Way Cab Availability",
    WhyChoosedescription: "Our Pune to Mumbai one way cab service is available 24 hours a day. Whether you need an early morning ride or a late night drop, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable travel experience between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Flexible Pickup & Drop Locations",
    WhyChoosedescription: "Velocity Cabs offers flexible pickup and drop options including homes, offices, hotels, railway stations, and airports across Pune and Mumbai for convenient one way travel."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs provides a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families, individuals, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from residential and commercial areas across Pune including Hinjewadi, Wakad, Baner, Kharadi, Hadapsar, Viman Nagar, and Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Pune to Mumbai one way cab bookings thanks to our punctual drivers, comfortable vehicles, and reliable intercity transportation service."
  }
]
};

const faqData = [
  { question: "Do you provide Pune to Mumbai one way cab service?", answer: "Yes, Velocity Cabs provides affordable and reliable one way cab services from Pune to Mumbai." },
  { question: "Is Pune to Mumbai one way cab service available 24 hours?", answer: "Yes, our one way cab service operates 24/7 to match customer travel needs." },
  { question: "Which vehicles are available for one way travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Do I need to pay for return fare in one way cab?", answer: "No, in one way cab service customers only pay for the single journey from Pune to Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and business centers across Pune." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book Pune to Mumbai one way cab online?", answer: "Yes, customers can easily book one way cab services online or through phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday travel periods." },
  { question: "Do you provide drop anywhere in Mumbai?", answer: "Yes, Velocity Cabs provides drop service to all areas across Mumbai including airport, railway stations, hotels, and residential locations." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Kulkarni",
    feedback:
      "A smooth and comfortable Pune to Mumbai one way journey. The cab was punctual, clean, and the highway ride felt relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Deshmukh",
    feedback:
      "The Pune to Mumbai one way cab service was very reliable. The vehicle was well-maintained, and the entire trip felt safe, steady, and hassle-free.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai One Way Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers affordable Pune to Mumbai one way cab service with reliable and professional drivers. Book one way taxis including sedan, Ertiga, Innova, and Innova Crysta for airport transfers and outstation travel. Enjoy safe, comfortable, and cheapest one way rides from Pune to Mumbai with flexible booking options.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      <Helmet>
  <title>Pune to Mumbai One Way Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai one way cab with Velocity Cabs. Cheapest one way taxi service with sedan, Ertiga, Innova & Crysta options. Reliable, safe & affordable Pune to Mumbai one way travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaionewaycab;